import { render, staticRenderFns } from "./AddUserToQuestionBankCohort.vue?vue&type=template&id=3646258c&scoped=true&"
import script from "./AddUserToQuestionBankCohort.vue?vue&type=script&lang=js&"
export * from "./AddUserToQuestionBankCohort.vue?vue&type=script&lang=js&"
import style0 from "./AddUserToQuestionBankCohort.vue?vue&type=style&index=0&id=3646258c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3646258c",
  null
  
)

export default component.exports